import axios from 'axios'
import { host } from '../../../helper/config'
import { FULL_LIST_ITEM_PER_PAGE } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-classic-list-rewards'

export const getAll = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        page: page,
        itemPerPage: FULL_LIST_ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}
